











import { Vue, Component, Prop } from 'vue-property-decorator';
import { CategoryItemViewModel } from '@/types/apiServerContract';
import { CategoryBlockViewModel } from '@/types/contentServerContract';
import Api from '@/project/http/Api.service';
import adnuntiusService from '@/project/personalization/adnuntius.service';
import CategoryBlockItem from './CategoryBlockItem.vue';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import { hexToRgbValues, luma } from '@/core/color/color.service';
import tailwind from '@/styling/tailwind.config';

@Component({
    components: { CategoryBlockItem, SmartHeadline }
})
export default class CategoryBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: CategoryBlockViewModel;

    @Prop({
        required: true,
        type: Boolean
    }) isFirstBlock!: boolean;

    get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }

    get backgroundColor() {
        return this.content.customBackgroundColor
            ? this.content.customBackgroundColor
            : this.content.backgroundColor ? '#' + this.content.backgroundColor : undefined;
    }

    get textColor() {
        if (!this.backgroundColor) return undefined;
        const { red, green, blue } = hexToRgbValues(this.backgroundColor);
        const isDarkBackground = luma(red, green, blue) <= 0.5;
        return isDarkBackground ? tailwind.theme.colors.white : tailwind.theme.colors.black;
    }

    get style(): Partial<CSSStyleDeclaration> {
        return {
            backgroundColor: this.backgroundColor,
            ...(this.backgroundColor && { paddingBottom: '15px' }),
            color: this.textColor
        };
    }

    categoryItems: CategoryItemViewModel[] = [];

    created() {
        this.getCategoryItems(this.content.settings?.selectedAdUnitIdContent?.adUnitId);
    }

    async getCategoryItems(adUnitId: string) {
        if (adUnitId) return;
        this.categoryItems = await Api.personalization.categories(
            adUnitId,
            this.$route.fullPath,
            adnuntiusService.getContactKey(),
            adnuntiusService.getCustomerKey());
    }
}
